export enum CustomerType {
    B2B = 'B2B',
    B2C = 'B2C',
}

export interface BaseAddressFormValues {
    customerType: CustomerType;
    companyName: string;
    vatNumber: string;
    firstName: string;
    lastName: string;
    street: string;
    extraInformation: string;
    hasLift: boolean;
    postalCode: string;
    city: string;
    country: string;
    phoneNumber: string;
    alternativePhoneNumber: string;
    email: string;
    confirmEmail: string;
    subscribeToNewsletter: boolean;
}
